import { ChevronDown } from "lucide-react";
import { useCurrency } from "@/context/CurrencyContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function CurrencySwitcher({ className = "" }) {
  const { currency, currencies, symbol, setCurrency } = useCurrency();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={`flex items-center gap-1 text-ink hover:text-brandblue transition-colors outline-none focus-visible:text-brandblue ${className}`}
          data-testid="currency-switcher-button"
          aria-label={`Currency: ${currency}`}
        >
          <span className="tabular-nums">{symbol}</span> {currency}
          <ChevronDown className="h-3 w-3" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-[140px] rounded-lg bg-white p-1"
        style={{ border: "1px solid #DBEAFE", boxShadow: "0 8px 24px rgba(30,58,138,0.10)" }}
        data-testid="currency-menu"
      >
        {currencies.map((c) => (
          <DropdownMenuItem
            key={c.code}
            onSelect={() => setCurrency(c.code)}
            className={`flex cursor-pointer items-center justify-between rounded-md px-3 py-2 text-sm outline-none focus:bg-brandbluelight focus:text-ink ${
              currency === c.code ? "font-semibold text-brandblue" : "text-ink"
            }`}
            data-testid={`currency-option-${c.code}`}
          >
            <span className="flex items-center gap-2">
              <span className="text-base leading-none">{c.flag}</span>
              <span>{c.label}</span>
            </span>
            <span className="font-mono text-xs text-subtle">{c.symbol}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
